import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-main">
          <div className="footer-column">
            <h4>Commodity Trading</h4>
            <ul>
              <li><a href="#maize">Maize (Corn)</a></li>
              <li><a href="#sugar">Bulk Sugar</a></li>
              <li><a href="#wheat">Wheat</a></li>
              <li><a href="#grains">Small Grains</a></li>
              <li><a href="#agro">Agro-products</a></li>
              <li><a href="#all">Shop All</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>Our Services</h4>
            <ul>
              <li><a href="#procurement">Procurement & Supply</a></li>
              <li><a href="#finance">Supply Chain Finance</a></li>
              <li><a href="#solutions">Integrated Solutions</a></li>
              <li><a href="#risk">Risk Management</a></li>
              <li><a href="#credit">Credit Solutions</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>Learn More</h4>
            <ul>
              <li><a href="#about" onClick={(e) => handleFooterClick(e, 'about')}>Our Story</a></li>
              <li><a href="#services" onClick={(e) => handleFooterClick(e, 'services')}>Global Markets</a></li>
              <li><a href="#sustainability" onClick={(e) => handleFooterClick(e, 'sustainability')}>Sustainability</a></li>
              <li><a href="#values" onClick={(e) => handleFooterClick(e, 'values')}>Trade Benefits</a></li>
              <li><a href="#faqs" onClick={(e) => handleFooterClick(e, 'faqs')}>FAQs</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>More from Oxycom</h4>
            <ul>
              <li><a href="#contact" onClick={(e) => handleFooterClick(e, 'contact')}>Contact Us</a></li>
              <li><a href="#careers">Career Opportunities</a></li>
              <li><a href="#partners">Partner With Us</a></li>
              <li><a href="#wholesale">Wholesale Opportunities</a></li>
              <li><a href="#affiliate">Affiliate Program</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>Connect With Us</h4>
            <ul>
              <li><a href="#" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
              <li><a href="#" target="_blank" rel="noopener noreferrer">Twitter</a></li>
              <li><a href="#" target="_blank" rel="noopener noreferrer">Facebook</a></li>
              <li><a href="#" target="_blank" rel="noopener noreferrer">Instagram</a></li>
              <li><a href="#" target="_blank" rel="noopener noreferrer">YouTube</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; 2025 Oxycom Group of Companies. All rights reserved.</p>
            </div>
            <div className="footer-links">
              <a href="#terms">Terms of Service</a>
              
            </div>
            <div className="footer-credits">
              <p>
                Developed by{' '}
                <a 
                  href="https://imperialsystemsmw.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="credit-link"
                >
                  Imperial Systems
                </a>{' '}
                in collaboration with{' '}
                <a 
                  href="https://beleae.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="credit-link"
                >
                  Belea Enterprise
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

// Add this function inside the component or as a separate function
const handleFooterClick = (e, sectionId) => {
  e.preventDefault();
  
  const element = document.getElementById(sectionId);
  if (element) {
    const headerHeight = 70;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
};

export default Footer;